import React from 'react';
import styled from 'styled-components';

import { ITab } from '../../../types/shared';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { Body } from '../../../styles/generic';

interface Props {
  selectedTab?: ITab;
  totalTabs: ITab[];
  onTabClick: (tab: ITab) => void;
}

const ToggleTabs = ({ selectedTab, totalTabs, onTabClick }: Props) => (
  <ButtonContainer data-testid="toggle-tab">
    {totalTabs.map((item, index) => (
      <TabButton
        disabled={item.disabled}
        data-element-label={item.label}
        data-element-type="button"
        data-component-type="toggle-tab"
        data-testid={`${
          selectedTab?.value === item.value ? 'active-' : ''
        }toggle-tab-button`}
        key={`tab-${index}`}
        activeTab={selectedTab?.value === item.value}
        type="button"
        onClick={() => {
          onTabClick(item);
        }}
      >
        <TabTitle data-testid="toggle-tab-title">{item.label}</TabTitle>
      </TabButton>
    ))}
  </ButtonContainer>
);

export default ToggleTabs;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;

  ${mq.from.breakpoint.M`
    margin-bottom: 40px;`}
  width: 100%;
`;

const TabButton = styled.button<{ activeTab: boolean }>`
  &:disabled {
    color: ${Colors.abnNeutral300};
    cursor: default;
  }
  background-color: transparent;
  border: none;
  border-bottom: 2px solid
    ${({ activeTab, theme }) =>
      activeTab ? theme.colors.abnGreen300 : Colors.abnNeutralsN65};
  color: ${({ theme }) => theme.colors.abnGreen300};
  cursor: pointer;
  padding: 12px;
  width: 100%;

  ${mq.from.breakpoint.M`
    &:hover:not(:disabled) {
      background-color: ${Colors.abnGreen50};
      cursor: pointer;
      border-bottom: 2px solid ${({ theme }) => theme.colors.abnGreen100};

      & > div {
        color: ${({ theme }) => theme.colors.abnGreen200};
      }
    }
  `}

  &:active:not(:disabled) {
    background-color: ${Colors.abnGreen55};
    border-bottom: 2px solid ${({ theme }) => theme.colors.abnGreen300};

    & > div {
      color: ${({ theme }) => theme.colors.abnGreen400};
    }
  }
`;

const TabTitle = styled(Body)`
  color: inherit;
`;
